import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import { loginService } from '@/components/_service/Users.js'
import * as localforage from "localforage";

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
  		status: '',
  		token: localStorage.getItem('token') || '',
  		user : {},
  		flights:[],
  		searching:{},
  		searchAble:{},
  		campReports:[],
  		camdetail:[],
  		currency:"",
  		AIOAcess:false,
  		campaignAios:[],
  		numberOfAioCount:0,
  		campaignApproval:[],
  		numberOfApprovalCount:0,
  		flightPendings:[],
		numberOfPendingCount:0,
  		flightCostings:[],
  		numberOfCostingCount:0,
  		flightDeletes:[],
  		numberOfDeleteCount:0,

  		flightMyPendings:[],
		numberOfMyPendingCount:0,
  		flightMyCostings:[],
  		numberOfMyCostingCount:0,
  		flightMyDeletes:[],
  		numberOfMyDeleteCount:0,


  		flightRequest:false,
  		updatestatus:false,
  		camlist:[],
  		total_record:0,
  		page_length:10,
  		start_record:0,
  		isLoading:false,
  		flightReports:[],
  		updaterejectaio:false,
  		updateverifyaio:false,
  		totalflightcount:0,
  		totalcamcount:0,
  		isSalePrivilege:false
	},
	mutations: {
		updateFlightRequest(state,flightRequest){
			state.flightRequest = flightRequest
		},
		updatestatus(state,updatestatus){
			state.updatestatus = updatestatus
		},
		updaterejectaio(state,updaterejectaio){
			state.updaterejectaio = updaterejectaio
		},
		updateverifyaio(state,updateverifyaio){
			state.updateverifyaio = updateverifyaio
		},
		auth_request(state){
	    	state.status = 'loading'
	  	},
	  	auth_success(state, token, user){
		    state.status = 'success'
		    state.token = token
		    state.user = user
	  	},
	  	auth_error(state){
	    	state.status = 'error'
	  	},
	  	logout(state){
	    	state.status = ''
	    	state.token = ''
	  	},
	  	flightDetail(state,flights) {
	      state.flights = flights;
	    },
	    clearFlight(state) {
	      state.flights = [];
	    },
	    searching(state,searchs) {
	      state.searching = searchs;
	    },
	    campReportdetail(state,campReports){
 			state.campReports = campReports;
	    },
	    camDetail(state,camdetail){
	    	state.camdetail = camdetail;
	    },
	    currency(state,currency){
	    	state.currency = currency;
	    },
	    checkCampaignVerifyAIOAccess(state,AIOAcess){
	    	state.AIOAcess = AIOAcess;
	    },
	    checkCampaignAccess(state,isSalePrivilege){
	    	state.isSalePrivilege = isSalePrivilege
	    },
	    campaignAIO(state,campaignAios){
	    	state.campaignAios =campaignAios
	    },
		numberOfAioCount(state,numberOfAioCount){
	    	state.numberOfAioCount =numberOfAioCount

		},
	    campaignApproval(state,campaignApproval){
	    	//console.log(campaignApproval)
	    	state.campaignApproval =campaignApproval

	    },
	    numberOfApprovalCount(state,numberOfApprovalCount){
	    	state.numberOfApprovalCount =numberOfApprovalCount
	    },
 		flightCosting(state,flightCosting){
	    	state.flightCostings =flightCosting

	    },
	    numberOfCostingCount(state,numberOfCostingCount){
			state.numberOfCostingCount = numberOfCostingCount
	    },
	    flightPending(state,flightPending){
	    	state.flightPendings =flightPending
	    },
	    numberOfPendingCount(state,numberOfPendingCount){
	    	state.numberOfPendingCount = numberOfPendingCount
	    },
		flightDelete(state,flightDelete){
	    	state.flightDeletes =flightDelete
	    },
	    numberOfDeleteCount(state,numberOfDeleteCount){
	    	state.numberOfDeleteCount = numberOfDeleteCount
	    },

	    flightMyCosting(state,flightMyCosting){
	    	state.flightMyCostings =flightMyCosting

	    },
	    numberOfMyCostingCount(state,numberOfMyCostingCount){
			state.numberOfMyCostingCount = numberOfMyCostingCount
	    },
	    flightMyPending(state,flightMyPending){
	    	state.flightMyPendings =flightMyPending
	    },
	    numberOfMyPendingCount(state,numberOfMyPendingCount){
	    	state.numberOfMyPendingCount = numberOfMyPendingCount
	    	//console.log(state.numberOfMyPendingCount )
	    },
		flightMyDelete(state,flightMyDelete){
	    	state.flightMyDeletes =flightMyDelete
	    },
	    numberOfMyDeleteCount(state,numberOfMyDeleteCount){
	    	state.numberOfMyDeleteCount = numberOfMyDeleteCount

	    },

	    camlist(state,camlist){
	    	state.camlist = camlist
	    },
	    page_length(state,page_length){
	    	//console.log(page_length)
	    	state.page_length = page_length
	    },
	    total_record(state,total_record){
	    	state.total_record =  total_record
	    },
	    start_record(state, start_record){
	    	state.start_record  = start_record
	    },
	   	flightReport(state, flightReports){
			state.flightReports  = flightReports
	   	},

    	loading(state, isLoading) {
	     // console.log({isLoading})
	      state.isLoading = isLoading;

		},

	},
	actions: {
	  	login({commit}, user){
	        return new Promise((resolve, reject) => {
	            commit('auth_request')
	            loginService.login(user)
		       .then(
	                user => {

	                	if(user.length == 0){
	                		commit('auth_error')
			      			localStorage.removeItem('token')
			        		reject(err)
	                	}
						else{

							//console.log('doi qui che')
						 	const token = localStorage.getItem('token')
						 	axios.defaults.headers.common['Authorization'] = token
						 	//console.log(token)
							commit('auth_success',token, user)
		                    resolve(user)
						}
	                }

	            )
	            .catch(err => {
			        commit('auth_error')
			      	localStorage.removeItem('token')
			        reject(err)
			     })

	        })
	    },

	  	logout({commit}){
		    return new Promise((resolve, reject) => {
		      	commit('logout')
		      	localStorage.removeItem('token')
		      	localforage.removeItem('userId')
	            localforage.removeItem('subscription')
	            localforage.removeItem('device')
	            localforage.clear().then(function() {
	                  // Run this code once the database has been entirely deleted.
	                //console.log('Database is now empty.');
	            }).catch(function(err) {
	                  // This code runs if there were any errors
	                console.error(err);
	            });

		      	delete axios.defaults.headers.common['Authorization']
		      	resolve()
		    })
	  	},
	  	////////////////////////////////////////
	  	flightFilterDate({commit}, search){
	  		commit('loading', true);
	    	return new Promise((resolve, reject) => {
	            commit('searching',true)
	            //const fl_id =11;
	           // console.log(search)
	             loginService.getFlightReport(search).then((data)=>{
          		 	const flight =  data;

          		 	commit('flightDetail', data)
          		 	//.data = this.paginator.data.concat(response.data.data);

          		 	commit('flightReport',data.flightreporttable)
     				//console.log(search)
          		 	commit('searching',search)
					commit('loading', false);
	                resolve(data)
          		 	//	console.log(flight.flightdetail)
                 // localStorage.setItem('currency', data.currency);
           		 });

	        })
	    },
	    ///////////////////////////////////////////////////////
	    campReportdetail({commit},search){
	    	//commit('loading', true);
	            commit('searching',true)
	    	return new Promise((resolve, reject) => {

	            //const fl_id =11;

	             loginService.getReportFull(search).then((data)=>{
          		 	const cams =  data;

          		 	commit('campReportdetail',cams)
          		 	commit('flightReport',cams.flightreporttable)
          		 	commit('searching',search)
          		 	commit('loading', false);
				//	commit('loading', false);
	                resolve(data)
          		 	//	console.log(flight.flightdetail)
                 // localStorage.setItem('currency', data.currency);
           		 });

	        })
	    },
	    camDetail({commit},id){
	    	commit('loading', true);
	    	return new Promise((resolve, reject) => {
	            commit('currency','MY')
	            commit('checkCampaignVerifyAIOAccess',false)
	           // const fl_id =11;

	             loginService.camdetail(id).then((data)=>{
          		 	const cams =  data;

          		 	// this.flightDetail =  flight.flightdetail
          		 	// this.camdetail = flight
          		 	commit('camDetail', cams)
          		 	commit('currency',cams.currency)
          		 	commit('checkCampaignVerifyAIOAccess',cams.AIOAcess)
					commit('loading', false);
	                resolve(data)

           		 });

	        })
	    },
	    checkCampaignAccess({commit}){
	    	return new Promise((resolve, reject) => {
	            commit('checkCampaignAccess',false)
	           // const fl_id =11;
	             loginService.getAIOAcess().then((data)=>{
                 	commit('checkCampaignAccess', data)

          		 //	console.log(data);
                 	resolve(data)
           		 });
	        })
	    },
	    getCampaignRequest({commit},strs){
	    	commit('loading', true);
	    	return new Promise((resolve, reject) => {
	    		commit('campaignAIO',[])
	    		commit('numberOfAioCount',0)
	    		if (strs==="campaign_aio"){
	    			loginService.getDashBoard(strs).then((data)=>{
	    				if (data){
	    					commit('numberOfAioCount',data['count'])
	    				//	console.log(data['amendment-request'])
		           			commit('campaignAIO',data['amendment-request'])
		           		}
				        resolve(data)
			    	 });
	    		}
	    		 commit('campaignApproval',[])
	    		 commit('numberOfApprovalCount',0)

	    		if(strs==="campaign_approval"){

	    			loginService.getDashBoard(strs).then((data)=>{

	    				//if(data){
	    					commit('numberOfApprovalCount',data['count'])
	    					//console.log(data['amendment-request'])
		           			commit('campaignApproval',data['amendment-request'])
	    				//}

		           		commit('loading', false);
				        resolve(data)
			    	 });
	    		}

	        })
	    },

	   getFlightRequest({commit},strs){
	    	 commit('loading', true);
	    	 const fc=0,pf=0,dl=0;
	    	return new Promise((resolve, reject) => {

	    		commit('flightCosting',[])
	    		commit('numberOfCostingCount',0)

	    		if (strs==="flight_costing"){


	    			loginService.getDashBoard(strs).then(data=>{
	    				//console.log(data)
	    				if (data){
	    					commit('flightCosting',data['amendment-request'])
		           			commit('numberOfCostingCount',data['count'])
	    				}

		           		//fc = data['count']

				        resolve(data)
			    	 });
	    		}

	    		 commit('flightPending',[])
	    		 commit('numberOfPendingCount',0)
	    		if(strs==="pending_flight"){

	    			loginService.getDashBoard(strs).then((data)=>{
	    				if(data){
	    					commit('flightPending',data['amendment-request'])
		           	//	console.log(data['count'])
		           			commit('numberOfPendingCount',data['count'])
	    				}

		           	//	pf=data['count']
				        resolve(data)
			    	 });
	    		}
	    		 commit('flightDelete',[])
	    		 commit('numberOfDeleteCount',0)
	    		if(strs==="delete_flight"){

	    			loginService.getDashBoard(strs).then((data)=>{
	    				if(data){
	    					commit('flightDelete',data['amendment-request'])
		           			commit('numberOfDeleteCount',data['count'])
	    				}

		           		commit('loading', false);
		           	//	dl=data['count']
				        resolve(data)
			    	 });
	    		}

	           // console.log(fc+pf+dl)
	        })
	    },
	    ////////////////// My Flight Request
	    getFlightMyRequest({commit},strs){
	    	 commit('loading', true);
	    	 const fc=0,pf=0,dl=0;
	    	return new Promise((resolve, reject) => {

	    		commit('flightMyCosting',[])
	    		commit('numberOfMyCostingCount',0)

	    		if (strs==="own_costing"){


	    			loginService.getDashBoard(strs).then(data=>{
	    				//console.log(data)
	    				if (data){
	    					commit('flightMyCosting',data['amendment-request'])
		           			commit('numberOfMyCostingCount',data['count'])
	    				}

		           		//fc = data['count']

				        resolve(data)
			    	 });
	    		}

	    		 commit('flightMyPending',[])
	    		 commit('numberOfMyPendingCount',0)
	    		if(strs==="own_pending"){

	    			loginService.getDashBoard(strs).then((data)=>{
	    				if(data){
	    					commit('flightMyPending',data['amendment-request'])
		           		//console.log(data['count'])
		           			commit('numberOfMyPendingCount',data['count'])
	    				}

		           	//	pf=data['count']
				        resolve(data)
			    	 });
	    		}
	    		 commit('flightMyDelete',[])
	    		 commit('numberOfMyDeleteCount',0)
	    		if(strs==="own_delete"){

	    			loginService.getDashBoard(strs).then((data)=>{
	    				if(data){
	    					commit('flightMyDelete',data['amendment-request'])
		           			commit('numberOfMyDeleteCount',data['count'])
	    				}

		           		commit('loading', false);
		           	//	dl=data['count']
				        resolve(data)
			    	 });
	    		}

	           // console.log(fc+pf+dl)
	        })
	    },

	    updateFlightRequest({commit},detail){
	    	return new Promise((resolve, reject) => {
	    		commit('updateFlightRequest',false)
	    		 loginService.flightRequest(detail ).then((data)=>{
	    		 		//console.log('data')
                		commit('updateFlightRequest',true)

				        resolve(data)
                 });
	   		})

	    },
	    updatestatus({commit},detail){
	    	return new Promise((resolve, reject) => {
	    		commit('updatestatus',false)
	    		 loginService.updatestatus(detail ).then((data)=>{
	    		 		//console.log('data')
                		commit('updatestatus',data)

				        resolve(data)
                 });
	   		})
	    },
	    updaterejectaio({commit},detail){
	    	return new Promise((resolve, reject) => {
	    		commit('updaterejectaio',false)
	    		 loginService.updaterejectaio(detail ).then((data)=>{
	    		 		//console.log('data')
                		commit('updaterejectaio',true)

				        resolve(data)
                 });
	   		})
	    },
	    updateverifyaio({commit},detail){
	    	return new Promise((resolve, reject) => {
	    		commit('updateverifyaio',false)
	    		 loginService.updateverifyaio(detail ).then((data)=>{
	    		 	//	console.log(data)
                		commit('updateverifyaio',data)

				        resolve(data)
                 });
	   		})
	    },

	    camlist({commit},search){
	    	commit('loading', true);
	    	return new Promise((resolve, reject) => {
	    		//commit('auth_request',false)

	    		 loginService.camlist(search ).then((data)=>{
	    		 		//console.log(data);
	    		 		commit('camlist',data[0])

	    		 		commit('page_length',data['page_length'])
	    		 		commit('total_record',data['total_record'])
	    		 		commit('start_record',data['start_record'])
                		//commit('auth_request',true)
						commit('loading', false);
				        resolve(data)
                 });
	   		})
	    },
	    camSearch({commit}, search){
	    	commit('loading', true);
	    	return new Promise((resolve, reject) => {
	    		//commit('auth_request',false)

	    		 loginService.camSearch(search).then(data=>{
	    		 		//console.log(data)
	    		 		if (data){
	    		 			commit('camlist',data[0])
	    		 			commit('page_length',data['page_length'])
	    		 			commit('total_record',data['total_record'])
	    		 			commit('start_record',data['start_record'])
	    		 		}else{
	    		 			commit('camlist',data)
	    		 		}




      //           		//commit('auth_request',true)
						commit('loading', false);
				        resolve(data)
                 });
	   		})
	    }

	},
	getters : {
	   isLoggedIn: state => !!state.token,
	   authStatus: state => state.status,
	   user:state => state.user,
	   loadedMeetup (state) {
		   //   return (meetupId) => {
		       // return state.loadedMeetups.find((meetup) => {
		          return '2019-07-09';
		       // })
		    //  }
   	    },
   	    loadedCampaignDetail (state) {

   	    	return state.campReports.campaigndetail;
   	    },

   	    loadedCampaignEleReport(state){
   	    	let returnArray = {
                frequency: state.campReports.frequency,
                page_length: state.campReports.page_length,
                totalER:state.campReports.totalER,
                totalEngagement: state.campReports.totalEngagement,
				total_record: state.campReports.total_record,
				totalclick:  state.campReports.totalclick,
				totalimpression:  state.campReports.totalimpression,
				avdClk: state.campReports.avdClk,

            }
   	    	return returnArray
   	    },
   	    loadedFlightDetail (state) {

   	    	return state.flights.flightdetail;
   	    },
   	    loadedFlightReportTotalRecord(state){
   	    	//console.log(state.flights.total_record)
   	    	return  state.flights.total_record;//state.flightDetail.total_record;
   	    },
   	    loadReportTotalRecord(state){
   	    	 return state.campReports.total_record;
   	    },
   	    loadReportPageLength(state){
   	    	 return state.campReports.page_length;
   	    },
   	    loadedFlightReport(state){
   	   		//console.log(state.flightReports)
   	    	return state.flightReports;

   	    },
   	    loadedFlightEleReport(state){

   	    	let returnArray = {
                frequency:state.flights.frequency,
              //  page_length:state.flights.page_length,
                totalER:state.flights.totalER,
                totalEngagement:state.flights.totalEngagement,
				//total_record:state.flights.total_record,
				totalclick:state.flights.totalclick,
				totalimpression:state.flights.totalimpression,
				avdClk:state.flights.avdClk,

            }
          //  console.log(returnArray)
   	    	return returnArray;
   	    },
   	    loadTotalRecord(state){

   	    	return state.flights.total_record;
   	    },
   	    loadCamlist(state){
   	    	//console.log( state.camlist)
   	    	return state.camlist;
   	    },
   	    loadCamTotalRecord(state){
   	    	//console.log(state.total_record)
   	    	if (!!state.total_record){
   	    		return state.total_record;
   	    	}else
   	    		return 0;

   	    },
   	    loadPageLength(state){
   	    	return state.page_length;
   	    },
   	    loadStartRecord(state){
   	    	return state.start_record;
   	    },
   	    // do totalflightcount use pushnotification
   	    loadedTotalFlightCount(state){
   	    //console.log(state.numberOfCostingCount + state.numberOfPendingCount + state.numberOfDeleteCount)
   	    	return (state.numberOfCostingCount + state.numberOfPendingCount + state.numberOfDeleteCount);
   	    },
   	    loadedTotalCamCount(state){
   	    	return (state.numberOfApprovalCount + state.numberOfAioCount)
   	    },
   	    loadedSaleAccess(state){
   	    	return state.isSalePrivilege
   	    }
	}
})
